var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pwa_article", {
    attrs: { pwa: _vm.pwa, article_type: "description" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }